import { c as _c } from "react/compiler-runtime";
import { DndContext, DragEndEvent, DragOverlay, DropAnimation, MeasuringStrategy, MouseSensor, TouchSensor, UniqueIdentifier, closestCenter, defaultDropAnimationSideEffects, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React, { useState } from 'react';
import { KeyedMutator } from 'swr';
import { changeCourseBundleItemPosition } from 'modules/courses/bundles/course-bundle/api/course-bundle-api';
import { CourseBundleInterface, CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import Course from 'modules/courses/bundles/course-bundle/components/course';
import CourseOverlay from 'modules/courses/bundles/course-bundle/components/course-overlay';
const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4'
      }
    }
  })
};
interface CourseBundleTableProps {
  items: CourseBundleItemInterface[];
  mutate: KeyedMutator<CourseBundleInterface>;
}
function CourseBundleTable(t0) {
  const $ = _c(25);
  const {
    items,
    mutate
  } = t0;
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      setActiveId(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onDragCancel = t1;
  let t2;
  if ($[1] !== items || $[2] !== mutate) {
    t2 = async t3 => {
      const {
        active,
        over
      } = t3;
      if (over && active.id !== over?.id) {
        const activeIndex = items.findIndex(t4 => {
          const {
            id
          } = t4;
          return id === active.id;
        });
        const overIndex = items.findIndex(t5 => {
          const {
            id: id_0
          } = t5;
          return id_0 === over.id;
        });
        const activeItem = items.find(t6 => {
          const {
            id: id_1
          } = t6;
          return id_1 === active.id;
        });
        const overItem = items.find(t7 => {
          const {
            id: id_2
          } = t7;
          return id_2 === over.id;
        });
        if (activeItem && overItem) {
          const clonedItems = [...items];
          await mutate(data => {
            if (data) {
              return {
                ...data,
                items: arrayMove(items, activeIndex, overIndex)
              };
            }
          }, false);
          ;
          try {
            await changeCourseBundleItemPosition(Number(active.id), {
              position: overIndex + 1
            });
          } catch (t8) {
            await mutate(data_0 => {
              if (data_0) {
                return {
                  ...data_0,
                  items: clonedItems
                };
              }
            }, false);
          }
        }
      }
      setActiveId(null);
    };
    $[1] = items;
    $[2] = mutate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onDragEnd = t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      droppable: {
        strategy: MeasuringStrategy.Always
      }
    };
    t4 = t5 => {
      const {
        active: active_0
      } = t5;
      setActiveId(active_0.id);
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== items || $[7] !== mutate) {
    let t6;
    if ($[9] !== mutate) {
      t6 = item => <Course key={item.id} item={item} mutate={mutate} />;
      $[9] = mutate;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = items.map(t6);
    $[6] = items;
    $[7] = mutate;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="mt-5 flex flex-col">{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== items || $[14] !== t6) {
    t7 = <SortableContext items={items} strategy={verticalListSortingStrategy}>{t6}</SortableContext>;
    $[13] = items;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== activeId || $[17] !== items || $[18] !== mutate) {
    t8 = activeId && <DragOverlay dropAnimation={dropAnimationConfig}><CourseOverlay item={items.find(item_0 => item_0.id === activeId)} mutate={mutate} /></DragOverlay>;
    $[16] = activeId;
    $[17] = items;
    $[18] = mutate;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== onDragEnd || $[21] !== sensors || $[22] !== t7 || $[23] !== t8) {
    t9 = <DndContext sensors={sensors} collisionDetection={closestCenter} measuring={t3} onDragStart={t4} onDragEnd={onDragEnd} onDragCancel={onDragCancel}>{t7}{t8}</DndContext>;
    $[20] = onDragEnd;
    $[21] = sensors;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
export default CourseBundleTable;